import type {
  SaleChannelFilter,
  SaleCommissionFilter,
  SaleFiscalStatusFilter,
  SaleSortDir,
  SaleSortKey,
  SaleStatusFilter,
} from '../domain/salesTypes';

/**
 * Resumen de alcance para la confirmación de export CSV.
 * Explicita período + filtros activos + orden para que el CSV nunca sea
 * una caja negra (proto ventas-ux-v1 §7).
 */
export function buildSalesExportScopeSummary(params: {
  dateRangeLabel: string;
  search?: string;
  statusFilter: SaleStatusFilter;
  cashierLabel?: string | null;
  primaryStaffLabel?: string | null;
  paymentMethodLabel?: string | null;
  fiscalStatusFilter: SaleFiscalStatusFilter;
  channelFilter: SaleChannelFilter;
  paymentPendingOnly: boolean;
  commissionFilter: SaleCommissionFilter;
  sortKey: SaleSortKey;
  sortDir: SaleSortDir;
}): string {
  const filters: string[] = [];
  const search = params.search?.trim();
  if (search) filters.push(`Búsqueda "${search}"`);
  if (params.statusFilter === 'voided') filters.push('Anuladas');
  if (params.cashierLabel) filters.push(`Operador ${params.cashierLabel}`);
  if (params.primaryStaffLabel) filters.push(`Atendió ${params.primaryStaffLabel}`);
  if (params.paymentMethodLabel) filters.push(`Medio ${params.paymentMethodLabel}`);
  if (params.fiscalStatusFilter === 'fiscal') filters.push('Fiscal');
  if (params.fiscalStatusFilter === 'non_fiscal') filters.push('No fiscal');
  if (params.fiscalStatusFilter === 'pending_sync') filters.push('Factura pendiente');
  if (params.channelFilter === 'pos') filters.push('Mostrador');
  if (params.channelFilter === 'online') filters.push('Pedido online');
  if (params.paymentPendingOnly) filters.push('Solo pendientes');
  if (params.commissionFilter === 'with') filters.push('Con comisión');
  if (params.commissionFilter === 'without') filters.push('Sin comisión');

  const sortLabel = (() => {
    switch (`${params.sortKey}:${params.sortDir}`) {
      case 'created_at:asc':
        return 'más vieja primero';
      case 'total:desc':
        return 'mayor monto primero';
      case 'total:asc':
        return 'menor monto primero';
      case 'cashier_user_id:asc':
        return 'operador A-Z';
      case 'cashier_user_id:desc':
        return 'operador Z-A';
      default:
        return 'más reciente primero';
    }
  })();

  const filtersPart = filters.length > 0 ? `Filtros: ${filters.join(', ')}` : 'Sin filtros';
  return `${params.dateRangeLabel} · ${filtersPart} · Orden: ${sortLabel}`;
}
